import React, { Component } from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


class PersonSelector extends React.Component {
    constructor(props) {
        super(props);

        this.id = props.match.params.id;
    }
    componentDidMount() {
        axios.defaults.baseURL = process.env.REACT_APP_EUNSA_BACKEND_URL + '/u/' + this.id;
        window.sessionStorage.setItem('u', this.id);
        window.localStorage.setItem('lastSelectedU', this.id);
    }

    render() {
        return <Redirect push to={{ pathname: '/' }} />;
    }
}

export default PersonSelector;



// WEBPACK FOOTER //
// ./src/containers/Full/PersonSelector.js